export function contenedorPadding() {
    const contenedor = document.querySelector('.contenedor');
    const header = document.querySelector('#header');
    let buscador = document.querySelector('#buscador-resultados.visible');
    if (!contenedor || !header) {
        return;
    }
    const alturaHeader = header.offsetHeight;
    if (buscador) {
        console.log('buscador');
        buscador.style.paddingTop = alturaHeader + 'px';
        contenedor.style.paddingTop = 0;
        return;
    }
    contenedor.style.paddingTop = alturaHeader + 'px';
}